"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryMulti = queryMulti;
exports.queryWithQueued = queryWithQueued;

var _rxjs = require("rxjs");

var _util = require("@polkadot/api-derive/util");

// Copyright 2017-2022 @darwinia/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
function unwrapSessionIds(stashId, queuedKeys, nextKeys) {
  const sessionIds = (queuedKeys.find(_ref => {
    let [currentId] = _ref;
    return currentId.eq(stashId);
  }) || [undefined, []])[1];
  const nextSessionIds = nextKeys.unwrapOr([]);
  return {
    nextSessionIds,
    sessionIds
  };
}

function retrieveCurr(api, stashId) {
  return api.derive.session.indexes().pipe((0, _rxjs.switchMap)(_ref2 => {
    var _api$consts$session;

    let {
      activeEra
    } = _ref2;
    return api.queryMulti([[api.query.staking.bonded, stashId], [api.query.staking.nominators, stashId], [api.query.staking.payee, stashId], [api.query.staking.validators, stashId], (_api$consts$session = api.consts.session) !== null && _api$consts$session !== void 0 && _api$consts$session.dedupKeyPrefix ? [api.query.session.nextKeys, [api.consts.session.dedupKeyPrefix, stashId]] : [api.query.session.nextKeys, stashId], [api.query.staking.erasStakers, [activeEra, stashId]]]);
  }));
}

function retrieveController(api, stashId, queuedKeys, _ref3) {
  let [controllerIdOpt, nominatorsOpt, rewardDestination, validatorPrefs, nextKeys, exposure] = _ref3;
  const controllerId = controllerIdOpt.unwrapOr(null);
  return controllerId ? api.query.staking.ledger(controllerId).pipe((0, _rxjs.map)(stakingLedgerOpt => ({
    accountId: stashId,
    controllerId,
    exposure,
    nominators: nominatorsOpt.isSome ? nominatorsOpt.unwrap().targets : [],
    stakingLedger: stakingLedgerOpt.unwrapOrDefault(),
    stashId,
    validatorPrefs: Array.isArray(validatorPrefs) ? validatorPrefs[0] : validatorPrefs,
    ...unwrapSessionIds(stashId, queuedKeys, nextKeys),
    rewardDestination
  }))) : (0, _rxjs.of)({
    accountId: stashId,
    controllerId: null,
    nextSessionIds: [],
    nominators: [],
    rewardDestination,
    sessionIds: [],
    stakingLedger: api.registry.createType('DarwiniaStakingStructsStakingLedger'),
    stashId,
    validatorPrefs: Array.isArray(validatorPrefs) ? validatorPrefs[0] : validatorPrefs
  });
}

function queryWithQueued(instanceId, api) {
  return (0, _util.memo)(instanceId, (accountId, queuedKeys) => {
    const stashId = api.registry.createType('AccountId', accountId);
    return retrieveCurr(api, stashId).pipe((0, _rxjs.switchMap)(result => retrieveController(api, stashId, queuedKeys, result)));
  });
}

function queryMulti(instanceId, api) {
  return (0, _util.memo)(instanceId, accountIds => accountIds.length ? api.query.session.queuedKeys().pipe((0, _rxjs.switchMap)(queuedKeys => (0, _rxjs.combineLatest)(
  /* eslint-disable @typescript-eslint/no-unsafe-return,
  @typescript-eslint/no-unsafe-call,
  @typescript-eslint/no-unsafe-member-access,
  @typescript-eslint/no-explicit-any */
  accountIds.map(acc => api.derive.staking.queryWithQueued(acc, queuedKeys))))) : (0, _rxjs.of)([]));
}